export const migrations = {
  0: (state: any) => {
    return {
      ...state,
    };
  },
};
